import * as React from "react";
import { forwardRef } from "react";
const SvgIcArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.9393 12.5001L4.5 12.5001V11.0001L16.9394 11.0001L13.6893 7.75011L14.75 6.68945L19.2803 11.2198V12.2804L14.75 16.8108L13.6893 15.7501L16.9393 12.5001Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcArrowRight);
export { ForwardRef as ReactComponent };
